import { render, staticRenderFns } from "./QAQuestionModal.vue?vue&type=template&id=4d1b9c6a"
import script from "./QAQuestionModal.vue?vue&type=script&lang=js"
export * from "./QAQuestionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports